import { ConnectionHubPageFilterInput, ConnectionHubPage } from '../../../gql/types';
import { useListConnectionHubPagesQuery } from '../../../gql/types'; // this import is from your generated code

interface UseConnectionHubPagesDataProps {
    filters?: ConnectionHubPageFilterInput;
}

export const useConnectionHubPagesData = ({ filters }: UseConnectionHubPagesDataProps = {}) => {
    const { data, loading, refetch } = useListConnectionHubPagesQuery({
        variables: { filters },
    });

    const pages: ConnectionHubPage[] = data?.fetchConnectionHubPages || [];

    return { pages, loading, refetch };
};
